import { useSearchParams } from 'react-router-dom';
import { CardButton } from '../../Buttons/CardButton';

export type DetailCTARendererProps = {
  data: object;
  value: string;
  valueFormatted: string;
  onClick?: () => void;
  // The search param that opens the drawer, for a surface whose drawer is not the inventory one.
  paramKey?: string;
  title?: string;
};

export function DetailCTARenderer({
  data,
  value,
  valueFormatted,
  onClick,
  paramKey = 'detailId',
  title
}: DetailCTARendererProps) {
  const valueString: string = valueFormatted || value;
  const [params, setParams] = useSearchParams();
  const compositeId = data['id' as keyof typeof data];
  const currentId = String(compositeId).split('|')[0];

  const handleDetailClick = () => {
    params.get(paramKey) === currentId ? params.delete(paramKey) : params.set(paramKey, currentId);
    setParams(params, { replace: true });
    if (onClick) onClick();
  };

  return (
    <div className="mt-3">
      <div className="desc-wrap">{valueString}</div>
      <CardButton
        title={title}
        data-testid="detail-cta-button"
        data-cy="detail-cta-button"
        onClick={handleDetailClick}
        className="h-4"
        icon="details"
      />
    </div>
  );
}
